module.exports = __webpack_public_path__ + "static/media/pinata.4fbf3f38.png";